import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap/modal";

export class ModalsComponent implements OnInit {
  action: EventEmitter<any> = new EventEmitter();  

  constructor(public modalRef:BsModalRef) { }

  ngOnInit() {
  }
  ok (data:any = true) {
    this.modalRef.hide(); 
    this.action.emit(data);
  }
  cancel () {
    this.modalRef.hide(); 
    this.action.emit(false);
  }
}
